<template>
  <v-layout wrap>
    <v-flex xs12>
      <p class="mb-2 f-16">
        {{ changesText }}
      </p>
      <p class="f-16 mb-1">
        {{ $t('manage_swr.modal.content.verify.proper_rows') }}
        <span class="sz_red--text"> {{ response.added_rows_count }}</span>
      </p>
      <p class="f-16 mb-1">
        {{ $t('manage_swr.modal.content.verify.invalid_rows') }}
        <span class="sz_red--text"> {{ response.invalid_rows_count }}</span>
      </p>
      <p
        v-if="hasRemovedRows"
        class="f-16"
      >
        {{ $t('manage_swr.modal.content.verify.removed_rows') }}
        <span class="sz_red--text"> {{ response.removed_rows_count }}</span>
      </p>
    </v-flex>
    <v-flex
      v-if="invalidRows"
      xs12
      my-3
    >
      <v-divider />
    </v-flex>
    <v-flex
      v-if="invalidRows"
      xs12
    >
      <p class="mb-2 f-16">
        {{ incorrectText }}
      </p>
      <a
        :href="response.result_filename"
        download
      >
        {{ fileName }}
      </a>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
    name: 'VerifyModalVerify',
    props: {
        response: {
            type: Object,
            required: true
        },
        executed: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    computed: {
        fileName () {
            return this.response.result_filename.replace(/^.*[\\/]/, '');
        },
        invalidRows () {
            return this.response.invalid_rows_count > 0;
        },
        hasRemovedRows () {
            return Object.prototype.hasOwnProperty.call(this.response, 'removed_rows_count');
        },
        changesText () {
            return this.executed
                ? this.$t('manage_swr.modal.content.verify.executed.changes')
                : this.$t('manage_swr.modal.content.verify.changes');
        },
        incorrectText () {
            return this.executed
                ? this.$t('manage_swr.modal.content.verify.executed.incorrect')
                : this.$t('manage_swr.modal.content.verify.incorrect');
        }
    }
};
</script>

<style scoped></style>
